// An account with several roles works in one at a time (STAGE_5 5.0): the switch in the
// header and on the doctor's screen; the desk has it in its "Sections".

import { Segmented } from 'antd';

import { ru } from '@/i18n/ru';

import type { Role } from './authContext';
import { useRoleSwitch } from './useRoleSwitch';

/** The modes side by side, the active one pressed; nothing for a single role. */
export function RoleSwitcher({ size }: { size?: 'small' | 'middle' | 'large' }) {
  const { roles, active, canSwitch, pending, switchTo } = useRoleSwitch();
  if (!canSwitch) return null;
  return (
    <Segmented<Role>
      aria-label={ru.header.mode}
      {...(size ? { size } : {})}
      disabled={pending}
      value={active}
      options={roles.map((role) => ({ value: role, label: ru.roles[role] }))}
      onChange={(role) => void switchTo(role)}
    />
  );
}
